import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "results"];
  static values = {
    url: String,
  };

  connect() {
    this.timeout = null;
  }

  search() {
    const query = this.inputTarget.value;

    // Clear previous timeout
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    // Don't search if query is too short
    if (query.length < 2) {
      this.resultsTarget.innerHTML = "";
      return;
    }

    // Debounce the search
    this.timeout = setTimeout(() => {
      this.performSearch(query);
    }, 300);
  }

  async performSearch(query) {
    try {
      const response = await fetch(
        `${this.urlValue}?q=${encodeURIComponent(query)}`,
        {
          headers: {
            Accept: "text/html",
          },
        }
      );

      if (response.ok) {
        const html = await response.text();
        this.resultsTarget.innerHTML = html;
      }
    } catch (error) {
      console.error("Account search error:", error);
      this.resultsTarget.innerHTML =
        '<div class="text-danger small">Error searching accounts</div>';
    }
  }
}
